import {assert} from 'assert-ts';
import type {PartValueModifier} from 'schemaDefinition/types';
import {isNullish} from 'schemaDefinition/functions';
import {isExpressionValue} from 'services/utils';
import {isWorkValue} from 'services/utils/functions/isWorkValue';
import {CodeListRef} from 'schemas';

export const languagesModifier: PartValueModifier = ({
  value,
  part,
  entityValue,
}) => {
  assert(
    isNullish(value) || Array.isArray(value),
    'languagesModifier: value must be null or an array',
    {value, part},
  );
  assert(
    isWorkValue(entityValue) || isExpressionValue(entityValue),
    'languagesModifier: entityValue must be Work or Expression',
    {entityValue, part},
  );

  if (!Array.isArray(value)) {
    return {value};
  }

  // Values without mul
  const values = ((value ?? []) as string[]).filter(
    v => v !== CodeListRef.LANGUAGE.Multi,
  );

  if (
    values.includes(CodeListRef.LANGUAGE.Bokmål) &&
    values.includes(CodeListRef.LANGUAGE.Nynorsk)
  ) {
    if (values.length >= 3) {
      return {
        value: [CodeListRef.LANGUAGE.Multi, ...values],
      };
    } else {
      return {value: values};
    }
  }

  if (values.length >= 2) {
    return {
      value: [CodeListRef.LANGUAGE.Multi, ...values],
    };
  }

  return {value: values};
};
